import React, { useMemo } from "react";
import dot_green from "../img/dot_green.png";
import dot_red from "../img/dot_red.png";
import dot_yellow from "../img/dot_yellow.png";
import dot_orange from "../img/dot_orange.png";

const ColourCellRenderer =(props) => {
  const imageForcolour = (colour) => {
    if(colour==='green') return dot_green;
    if(colour==='red') return dot_red;
    if(colour==='yellow') return dot_yellow;
    if(colour==='orange') return dot_orange;
  }

  const colour = useMemo(() => imageForcolour(props.value), [props.value]);

  return (
    <div className="colour-renderer">
      <img width="20px" src={colour} alt="colour"/>
    </div>
  );
};

export default ColourCellRenderer;
